module.exports = __webpack_public_path__ + "static/media/vk-product-logo.e68b33c3.svg";